module.exports = __webpack_public_path__ + "static/media/03d.aee4a6ec.png";